import React from 'react';
import HeadingButtonBase from './HeadingButtonBase';

function HeadingOneButton() {
  return <HeadingButtonBase format="heading_one" title="H1" />;
}

export default HeadingOneButton;
